/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signuphintoff2Inputs */

const en_signuphintoff2 = /** @type {(inputs: Signuphintoff2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Off`)
};

const de_signuphintoff2 = /** @type {(inputs: Signuphintoff2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aus`)
};

/**
* | output |
* | --- |
* | "Off" |
*
* @param {Signuphintoff2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signuphintoff2 = /** @type {((inputs?: Signuphintoff2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signuphintoff2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signuphintoff2(inputs)
	return de_signuphintoff2(inputs)
});
export { signuphintoff2 as "signupHintOff" }